import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: '首页' },
    { path: '/categories', label: '分类浏览' },
    { path: '/about', label: '关于我们' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18 max-w-[1400px] mx-auto">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500">
              <span className="text-white font-bold text-lg md:text-xl font-heading">J</span>
            </div>
            <span className={`font-heading font-bold text-xl md:text-2xl transition-colors duration-300 ${
              scrolled ? 'text-foreground-900' : 'text-white'
            }`}>
              JMTT
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                  location.pathname === link.path
                    ? scrolled ? 'text-primary-600' : 'text-primary-300'
                    : scrolled ? 'text-foreground-700 hover:text-foreground-900' : 'text-white/80 hover:text-white'
                }`}
              >
                {link.label}
                {location.pathname === link.path && (
                  <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-primary-500 rounded-full" />
                )}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                scrolled ? 'text-foreground-700 hover:text-foreground-900' : 'text-white/80 hover:text-white'
              }`}
            >
              登录
            </Link>
            <Link
              to="/about"
              className={`text-sm font-semibold whitespace-nowrap px-5 py-2.5 rounded-lg transition-all duration-200 cursor-pointer ${
                scrolled
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white/20 text-white backdrop-blur-sm hover:bg-white/30 border border-white/30'
              }`}
            >
              立即注册
            </Link>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled ? 'text-foreground-900 hover:bg-background-100' : 'text-white hover:bg-white/10'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === link.path
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-3 flex flex-col gap-2">
              <Link
                to="/about"
                className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer text-center"
              >
                登录
              </Link>
              <Link
                to="/about"
                className="block px-4 py-3 rounded-lg text-sm font-semibold bg-primary-500 text-white hover:bg-primary-600 transition-colors cursor-pointer text-center"
              >
                立即注册
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}